<template>
  <!-- 将 :visible.sync="visible" 修改为 :visible="dialogVisible" -->
  <el-dialog
    title="账号登录/注册"
    :visible="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <template #title>
      <div class="dialog-header">
        <img 
          :src="adLogin?.coverurl || site?.logourl" 
          alt="logo" 
          style="width: 130px;" 
        />
      </div>
    </template>
    
    <!-- 使用 el-tabs 实现标签页切换 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- 手机号注册标签页 -->
      <el-tab-pane label="手机号登录/注册" name="phoneRegister">
        <el-form 
          :model="registerForm" 
          :rules="registerRules" 
          ref="registerForm" 
          label-position="top" 
          label-width="100px"
          aria-label="注册表单"
        >
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="registerForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="图形验证码" prop="captcha" class="captcha-item">
            <el-input v-model="registerForm.captcha" placeholder="请输入图形验证码">
              <template #append>
                <div class="captcha-container">
                  <img 
                    :src="captchaurl" 
                    alt="图形验证码" 
                    @click="getCaptchaImage"
                    style="cursor: pointer; height: 100%; max-width: 90px; object-fit: contain;"
                  >
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="短信验证码" prop="smsCode">
            <el-input v-model="registerForm.smsCode" placeholder="请输入短信验证码">
              <template #append>
                <el-button @click="sendSmsCode" :disabled="smsCodeDisabled" size="small">
                  {{ smsCodeText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>


      <!-- 密码登录标签页 -->
      <el-tab-pane label="密码登录" name="passwordLogin">
        <el-form 
          :model="loginForm" 
          :rules="loginRules" 
          ref="loginForm" 
          label-position="top" 
          label-width="100px"
          aria-label="登录表单"
        >
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="loginForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" class="password-item">
            <el-input 
              v-model="loginForm.password" 
              show-password
              placeholder="请输入密码"
            >
              <template slot="append">
                <div class="forgot-password" @click="handleForgotPassword">忘记密码？</div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>

    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button 
        type  = "primary"
        @click= "handleSubmit" 
        size  = "medium" 
      >
        {{ activeTab === 'passwordLogin' ? '登 录' : '确 定' }}
      </el-button>
    </span>

    <!-- 社交账号登录：微信、支付宝、抖音等 -->
    <span slot="footer" class="dialog-button">
      <div class="label">社交账号登录：</div>
      <div>
        <div class="social-icon wechat" @click="handleLogin('wechat')">
          <svg data-v-199712a6="" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" height="1em" class="svg2vue icon-wechat icon icon-wechat"><path d="M10.777 4.102c.18 0 .359.013.538.033C10.833 1.889 8.432.22 5.691.22 2.627.22.118 2.308.118 4.96c0 1.53.834 2.787 2.23 3.763L1.791 10.4l1.948-.977c.697.137 1.256.279 1.952.279.175 0 .349-.008.52-.02a4.179 4.179 0 01-.172-1.17c0-2.435 2.091-4.411 4.738-4.411zM7.78 2.59c.421 0 .698.276.698.696 0 .417-.277.696-.698.696-.417 0-.836-.28-.836-.696 0-.42.418-.696.836-.696zm-3.9 1.392c-.42 0-.84-.28-.84-.696 0-.42.42-.696.84-.696.418 0 .695.275.695.696 0 .417-.277.696-.696.696z"></path> <path d="M15.865 8.446c0-2.228-2.23-4.044-4.735-4.044-2.652 0-4.74 1.817-4.74 4.044 0 2.234 2.089 4.044 4.74 4.044.555 0 1.115-.139 1.672-.278l1.529.838-.42-1.394c1.12-.84 1.954-1.953 1.954-3.21zm-6.272-.698c-.277 0-.557-.276-.557-.557 0-.278.28-.557.557-.557.423 0 .698.28.698.557 0 .281-.275.557-.698.557zm3.066 0c-.275 0-.555-.276-.555-.557 0-.278.279-.557.555-.557.419 0 .697.28.697.557 0 .281-.278.557-.697.557z"></path></svg>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { getAds, clickPlacement } from '@/api/placement';
import config from '@/config';

import { 
  captchaImage,
  postLoginOtp,
  postSigninOtp,
  postLogin
} from "@/api/auth";

export default {
  name: "LoginRegisterDialog",
  inject: ['siteData'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 新增：控制默认激活的标签页
    defaultTab: {
      type: String,
      default: 'phoneRegister'
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      activeTab: this.defaultTab, // 当前激活的标签页
      profile: {},
      // 登录表单数据
      loginForm: {
        account: '',
        password: ''
      },
      // 登录表单验证规则
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ]
      },
      // 注册表单数据
      registerForm: {
        phone: '',
        captcha: '',
        smsCode: '',
        name: '',
        company: '',
        position: ''
      },
      // 注册表单验证规则
      registerRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        captcha: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
      },
      captchaurl: '',
      captchaid: '',
      smsCodeDisabled: false,
      smsCodeText: '获取短信验证码',
      smsCodeCountdown: 60,
      otp:'',
      adLogin:null
    };
  },
  computed: {
    site() {
      return this.siteData.site;
    }
  },
  created() {
    this.fetchAdsLogin();
    // console.log('LoginRegisterDialog site:', this.site);
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal; // 添加这一行
      if (newVal && this.activeTab === 'phoneRegister') {
        this.getCaptchaImage();
      }
    },
    defaultTab(newVal) {
      this.activeTab = newVal;
    },
    site(newVal) {
      console.log('LoginRegisterDialog site updated:', newVal);
    }
  },
  methods: {
    handleClose() {
      // 保持原有的事件触发逻辑
      this.$emit('update:visible', false);
    },
    handleTabClick(tab) {
      // 切换标签时清除对应表单的验证
      if (tab.name === 'passwordLogin' && this.$refs.registerForm) {
        this.$refs.registerForm.clearValidate();
      } else if (tab.name === 'phoneRegister' && this.$refs.loginForm) {
        this.$refs.loginForm.clearValidate();
        this.getCaptchaImage(); // 切换到注册标签时刷新验证码
      }
    },
    getCaptchaImage() {
      captchaImage().then((result) => {
        if (result.code === 201) {
          const res = result.data;
          this.captchaurl = res.captcha;
          this.captchaid = res.captchaid;
        }
      });
    },
    async sendSmsCode() {
      //判断账号是否是手机号
      if (!/^1[3-9]\d{9}$/.test(this.registerForm.phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
      
      try {
        const res = await postSigninOtp(this.registerForm.phone, this.captchaid, this.registerForm.captcha);
        if (res.code === 201) {
          // console.log('postSigninOtp:',res);
          this.$message.success('短信验证码发送成功');
          this.startSmsCountdown();
          this.otp = res.otp;
        } else {
          this.$message.error(res.err || '发送短信验证码失败，请重试');
        }
      } catch (error) {
        this.$message.error('发送短信验证码失败，请重试');
      }
    },
    startSmsCountdown() {
      this.smsCodeDisabled = true;
      this.smsCodeText = `${this.smsCodeCountdown}s 后重试`;
      const timer = setInterval(() => {
        this.smsCodeCountdown--;
        this.smsCodeText = `${this.smsCodeCountdown}s 后重试`;
        if (this.smsCodeCountdown <= 0) {
          clearInterval(timer);
          this.smsCodeDisabled = false;
          this.smsCodeText = '获取短信验证码';
          this.smsCodeCountdown = 60;
        }
      }, 1000);
    },
    async handleSubmit() {
      if (this.activeTab === 'phoneRegister') {
        await this.submitSmsLogin(); // 手机验证码登录
      } else if (this.activeTab === 'passwordLogin') {
        await this.submitPasswordLogin(); // 密码登录
      }
    },
    
    async submitPasswordLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            const response = await postLogin(
              this.loginForm.phone, 
              { password: this.loginForm.password } // 传递密码参数
            );
            if (response.code === 201) {
              this.$message.success('登录成功');
              this.$emit('registerSuccess', response.data.token);
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('initpwd', true);
              this.handleClose();
            } else {
              this.$message.error(response.err || '登录失败，请重试');
            }
          } catch (error) {
            this.$message.error('登录失败，请重试');
          }
        }
      });
    },
    
    async submitSmsLogin() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          try {
            // 手机验证码登录：传递手机号和 otp 对象
            const response = await postLoginOtp(
              this.registerForm.phone, 
              { otp: this.registerForm.smsCode } // 传递验证码参数
            );
            if (response.code === 201) {
              console.log('postLoginOtp:',response);
              this.$message.success('登录成功');
              this.$emit('registerSuccess', response.data.token);
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('initpwd', response.data.initpwd);
              this.handleClose();
            } else {
              this.$message.error(response.err || '登录失败，请重试');
            }
          } catch (error) {
            this.$message.error('登录失败，请重试');
          }
        }
      });
    },
    handleForgotPassword() {
      this.$router.push({ name: 'ResetPwd' });
    },
    handleLogin(type) {
      console.log(type);
      this.$message.info(`敬请期待`);
    },
    async fetchAdsLogin(){
      try {
        const adsResponse = await getAds(config.AD_LOGINPAGETOPHORIZONTALFIXEDBANNER);
        this.adLogin = adsResponse.data?.[0] || {}; 
        this.isLoading = false;
      } catch (error) {
        // 添加错误处理
        console.log('画廊广告加载失败:', error);
        this.isLoading = false;
      }      
    },
    handleClick() {
      if (this.adLogin && this.adLogin.link && this.adLogin.id) {
        const url = clickPlacement(this.adLogin.id, this.adLogin);
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.dialog-footer button{
  width: 100%;
  height: 56px;
  font-size: 16px;
}

.dialog-footer button span{
  font-size: 16px;
}


.dialog-button{
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.dialog-button .label{
  margin-right: 10px;
  font-size: 14px;
  color: #222;
}

.dialog-button .social-icon{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #999;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
}
.dialog-button .social-icon .icon{
  position: relative;
  width: 22px;
  fill: #fff;
  transition: 0.3s;
  pointer-events: none;
}
.wechat:hover{
  background-color: #1f995c;
}

.captcha-container {
  height: 100%;
  display: flex;
  align-items: center;
}
:deep(.captcha-item .el-input-group__append) {
  background: unset;
  border: unset;
}
:deep(.el-form-item){
  margin-bottom: 20px !important;
}
:deep(.el-form-item__error) {
  line-height: 0;
  padding-top: 9px !important;
}
:deep(.el-dialog__header){
  background: #333940;
  padding: 20px 15px;
  text-align: left;
}
/* 标签页样式调整 */
:deep(.el-tabs__nav) {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 15px 0 5px;
}
:deep(.el-tabs__content) {
  padding-top: 10px;
}
:deep(.el-dialog__body){
  padding: 9px 20px;
}
:deep(.el-tabs__item.is-active){
  font-size: 16px;
}
:deep(.el-dialog__headerbtn){
  font-size: 26px;
  top: 30px;
}
:deep(.el-form-item__label){
  line-height: 1;
}
:deep(.el-form--label-top .el-form-item__label){
  padding: 0;
}

:deep(.password-item .el-input-group__append) {
  background-color: #ffffff;
  /* 添加自定义分隔线 */
  position: relative;
  padding-left: 24px; /* 增加左侧内边距，为短分隔线留出空间 */
}

:deep(.password-item .el-input-group__append)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 25%; /* 垂直居中 */
  bottom: 25%; /* 控制分隔线高度 */
  width: 1px;
  background-color: #dcdfe6; /* 使用Element UI默认边框颜色 */
}

/* 修改密码输入框样式 */
:deep(.password-item .el-input__inner) {
  /* 仅在未选中时隐藏右侧边框 */
  border-right-color: transparent !important;
  transition: border-color 0.2s;
}

/* 输入框获得焦点时显示右侧边框 */
:deep(.password-item .el-input__inner:focus) {
  border-right-color: #409EFF !important; /* 使用Element UI主题色 */
}

/* 添加错误状态下的右侧边框样式 */
:deep(.password-item.is-error .el-input__inner) {
  border-right-color: #F56C6C !important; /* 使用Element UI错误颜色 */
}

/* 调整分隔线样式以匹配边框 */
:deep(.password-item .el-input-group__append)::before {
  content: '';
  position: absolute;
  left: 0;
  top: 15%; /* 垂直居中 */
  bottom: 15%; /* 控制分隔线高度 */
  width: 1px;
  background-color: #dcdfe6; /* 使用Element UI默认边框颜色 */
}

.forgot-password {
  cursor: pointer;
  font-size: 12px;
}




</style>
